import type { ResponsePostBusinessFormType } from '@/components/organisms/BusinessContactForm';

import {
    SEND_BUSINESS_FORM_API_URL,
    SEND_BUSINESS_FORM_N8N_API_URL,
} from './constants';

export const postBusinessContactForm = async (
    formData: FormData,
): Promise<ResponsePostBusinessFormType> => {
    const response = await fetch(SEND_BUSINESS_FORM_API_URL, {
        method: 'POST',
        body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(
            'Wystąpił błąd wysyłania formularza. Spróbuj ponownie później.',
        );
    }

    return {
        message: data.message,
        status: response.status,
    };
};

export const postBusinessContactFormToN8N = async (
    formData: FormData,
): Promise<ResponsePostBusinessFormType> => {
    const response = await fetch(SEND_BUSINESS_FORM_N8N_API_URL, {
        method: 'POST',
        body: formData,
    });

    const data = await response.json();

    return {
        message: data.message,
        status: response.status,
    };
};
